import { render, staticRenderFns } from "./AnexosComponent.vue?vue&type=template&id=51c6eb8a&"
import script from "./AnexosComponent.vue?vue&type=script&lang=js&"
export * from "./AnexosComponent.vue?vue&type=script&lang=js&"
import style0 from "./AnexosComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports